import { useTheme } from "@mui/material/styles";

export const drawerWidth = 240;
// The Drawer's own collapsed width (drawerPaperClose below) is derived from
// these two constants, so the fixed top bar's left-offset can never drift
// out of sync with the Drawer's actual rendered width.
export const collapsedDrawerWidthXs = 56;
export const collapsedDrawerWidthSm = 72;
export const topBarHeight = 56;

export const useNavStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: "flex",
    },
    drawerPaper: {
      display: "flex",
      flexDirection: "column" as const,
      position: "relative" as const,
      whiteSpace: "nowrap" as const,
      width: drawerWidth,
      height: "100vh",
      // The paper itself never scrolls; only the nav-items list inside does
      // (see navScrollArea), so the logo header and the profile/logout footer
      // stay pinned while a long nav list scrolls between them.
      overflow: "hidden" as const,
      // An explicit border, guaranteed to span the drawer's full height,
      // rather than relying on incidental background contrast with content.
      borderRight: 1,
      borderColor: "divider",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: "hidden" as const,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: collapsedDrawerWidthXs,
      [theme.breakpoints.up("sm")]: {
        width: collapsedDrawerWidthSm,
      },
    },
    // The only scrollable region of the drawer: the nav items. Grows to fill
    // the space between the fixed logo header and the fixed footer, scrolling
    // internally when the items overflow.
    navScrollArea: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto" as const,
      // A deliberately subtle scrollbar: a faint thumb over a transparent track
      // (the rail is always dark, so a low-alpha white thumb reads gently in
      // both app themes), brightening slightly on hover. Kept thin rather than
      // using scrollbar-gutter, which would leave a permanent gap.
      scrollbarWidth: "thin" as const,
      scrollbarColor: "rgba(255, 255, 255, 0.15) transparent",
      "&::-webkit-scrollbar": {
        width: 6,
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        borderRadius: 3,
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.3)",
      },
    },
    paper: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column" as const,
    },
    fixedHeight: {
      height: 240,
    },
    versionDisplay: {
      fontSize: 12,
    },
  };
};

// For backward compatibility
const navStyles = useNavStyles;
export default navStyles;
